/**
 * 视口区域内曝光
 */

import { trackEvent } from '@/common/track';

export class Observer {
  constructor({ element, key, name, params, threshold=0, rootMargin = "0"}) {
    this._Observer = null;
    this._isTrack = false;
    this.element = element;
    this.key = key;
    this.name = name;
    this.trackParams = params;
    this.threshold = threshold; 
    this.rootMargin = rootMargin;
  }

  // 主要实现逻辑
  observer() {
    try {
      if (__mpx_mode__ === 'web') {
        
        const ele = document.querySelector(`#${this.element}`);
        const root = document.querySelector(`#${this.root}`) || null
        this._Observer = new IntersectionObserver(
          options => {
            // 如果曝光区域大于设置阈值 上报埋点
            if (options[0].intersectionRatio > this.threshold) {
              this.observerCallback();
            }
          },
          { threshold: [this.threshold], 
            threshold:this.threshold,
            rootMargin: this.rootMargin
          }
        );
        
        this._Observer.observe(ele);
      }
    } catch (e) {
      this.viewTrack();
    }
  }

  openObserver() {
    this._isTrack = false;
    setTimeout(() => {
      this.observer();
    });
  }

  clearObserver() {
    this._Observer?.disconnect();
  }

  viewTrack() {
    trackEvent(this.key, this.name, this.trackParams);
  }

  observerCallback() {
    if (this._isTrack) return;
    this._isTrack = true;
    this.viewTrack();
  }
}

export const createObserver = ({
  element,
  root,
  key,
  name,
  params,
  continued = false,
  threshold = 0.95,
  rootMargin = '0px',
}) => {
  let _Observer = null
  let _isTrack = false
  let canTrackAgain = false

  // 检查element选择器是否存在
  const ele = document.querySelector(`#${element}`)
  if (!ele) {
    console.error(`Element with id ${element} not found.`)
    return null
  }

  // 检查root选择器是否存在
  const rootElement = root ? document.querySelector(`#${root}`) : null
  if (root && !rootElement) {
    console.error(`Root element with id ${root} not found.`)
    return null
  }

  // 检查threshold是否在合理范围内
  if (threshold < 0 || threshold > 1) {
    console.error(`Threshold ${threshold} is out of range. It should be between 0 and 1.`)
    return null
  }

  const viewTrack = () => {
    trackEvent(key, name, params)
  }

  const observerCallback = (entries) => {
    const entry = entries[0]
    // 如果曝光区域大于设置阈值且允许上报埋点
    if (entry.intersectionRatio > threshold && (!_isTrack || canTrackAgain)) {
      _isTrack = true
      viewTrack()
      canTrackAgain = false // 重置状态，防止连续触发
    }
    // 曝光度小于0.05且之前已经曝光过，允许再次曝光
    if (entry.intersectionRatio <= 0.05 && _isTrack && continued) {
      canTrackAgain = true
    }
  }

  const observer = () => {
    try {
      if (__mpx_mode__ === 'web') {
        _Observer = new IntersectionObserver(observerCallback, {
          threshold: [0, 0.05, threshold].sort((a, b) => a - b), // 添加0和0.05作为观察阈值
          root: rootElement,
          rootMargin,
        })

        _Observer.observe(ele)
      }
    } catch (e) {
      console.error('Failed to initialize IntersectionObserver:', e)
      viewTrack()
    }
  }

  const openObserver = () => {
    _isTrack = false
    canTrackAgain = false // 打开观察时重置可以再次跟踪的状态
    setTimeout(observer)
  }

  const clearObserver = () => {
    _Observer?.disconnect()
  }

  // 自动开启观察
  openObserver()

  // 返回带有关闭观察者的方法的对象
  return {
    closeObserver: clearObserver,
  }
}
